import React from 'react';
import { useLocation, Navigate } from 'react-router';

import { SIGN_IN } from 'config/url';
import useLoadUser from 'hooks/useLoadUser';

import Footer from 'components/Footer';
import Navbar from 'components/Nav';
import Spinner from 'components/Spinner';


const RequireLogin = ({children}) => {
  const user = useLoadUser();
  const location = useLocation();
  if (user.isLoading) {
    return <Spinner size="3x"/>
  }
  if(!user.isAuthenticated) {
    return <Navigate to={SIGN_IN} state={{from: location}} />
  }

  return children;
}

const PrivatePage = ({ navbarProps, children }) => (
  <RequireLogin>
    <div className="flex-wrapper has-background-white">
      <Navbar {...navbarProps} />
      <section className="page py-5">
        {children}
      </section>
      <Footer />
    </div>
  </RequireLogin>
)

export default PrivatePage;
